import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import auth from "./auth";
import coinReg from "./coinReg";
import alarmReg from "./alarmReg";
import alarmRsi from "./alarmRsi";
import alarmScore from "./alarmScore";
import alarmVol from "./alarmVol";
import rsiTrade from "./rsiTrade";
import user from "./user";
import board from "./board";
import setApi from "./setApi";
import loginStatus from "./loginStatus";
import alarmSmart from "./alarmSmart";
import lightAlarm from "./alarmLight";
import tab from "./tab"

const store = createStore({
  modules: {
    auth,
    coinReg,
    alarmReg,
    alarmRsi,
    rsiTrade,
    board,
    user,
    setApi, //api 등록,삭제,연동
    alarmScore,
    alarmVol,
    loginStatus,
    alarmSmart,
    lightAlarm,
    tab
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage,
      paths: ["board.noticeDetail"], 
    }),
  ],
});

export default store;
